import React from 'react';
import { Route, Switch } from 'react-router';
import Analytics from './Analytics';

const Artist = () => (
  <Switch>
    <Route exact path="/artist-profile/analytics" component={Analytics} />
  </Switch>
);

export default Artist;



// WEBPACK FOOTER //
// ./src/containers/Artist/index.js